import React from 'react';
import { Link } from 'react-router-dom';
import { Check, CheckCircle } from 'lucide-react';
import { roadmapSteps } from '../mock';

export const RoadmapSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-cream">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-gray-900 mb-4">
            Feuille de Route du Débutant
          </h2>
          <p className="text-lg text-gray-600">
            Suivez ces 4 étapes essentielles pour installer votre première ruche urbaine en toute sécurité.
          </p>
        </div>

        {/* Timeline - Horizontal on desktop, vertical on mobile */}
        <div className="max-w-6xl mx-auto">
          {/* Desktop Timeline */}
          <div className="hidden lg:block">
            <div className="relative">
              {/* Horizontal connecting line - Much more visible */}
              <div className="absolute top-12 left-[12%] right-[12%] h-2 bg-sage rounded-full shadow-md"></div>
              
              <div className="grid grid-cols-4 gap-4">
                {roadmapSteps.map((step, index) => (
                  <div key={step.number} className="relative group">
                    {/* Step Circle - Better contrast */}
                    <div className="timeline-circle relative z-20 mx-auto w-24 h-24 rounded-full border-4 flex items-center justify-center shadow-xl transition-all duration-300 group-hover:scale-110">
                      <span className="timeline-number text-4xl font-bold z-10 transition-colors duration-300">{step.number}</span>
                    </div>

                    {/* Step Content Card */}
                    <div className="mt-8 bg-white rounded-xl shadow-lg p-6 border-4 border-gray-200 group-hover:border-honey group-hover:shadow-2xl group-hover:-translate-y-2 transition-all duration-300">
                      <h3 className="text-lg font-bold text-gray-900 mb-3 text-center">
                        {step.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed text-center">
                        {step.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Mobile Timeline - Vertical */}
          <div className="lg:hidden">
            <div className="relative">
              {/* Vertical connecting line - More visible */}
              <div className="absolute left-12 top-12 bottom-12 w-2 bg-sage rounded-full shadow-md"></div>
              
              <div className="space-y-8">
                {roadmapSteps.map((step, index) => (
                  <div key={step.number} className="relative flex items-start gap-6">
                    {/* Step Circle - Better contrast */}
                    <div className="flex-shrink-0 relative z-20 w-24 h-24 rounded-full bg-white border-4 border-sage flex items-center justify-center shadow-xl">
                      <span className="text-3xl font-bold text-sage z-10">{step.number}</span>
                    </div>

                    {/* Step Content Card */}
                    <div className="flex-grow bg-white rounded-xl shadow-lg p-6 border-2 border-transparent hover:border-honey transition-all">
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {step.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-16">
            <Link to="/getting-started">
              <button className="inline-flex items-center px-8 py-4 border-2 border-sage text-sage hover:bg-sage/90 hover:text-cream hover:border-sage/90 font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all">
                <Check className="mr-2 h-5 w-5" />
                Commencer Mon Projet
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
